import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter, FlexCenter } from '../../../global/commonStyle';

interface Props {
  hasHours?: boolean;
  isRecorded?: boolean;
}

const RecordTime = styled.div`
  width: 100%;
  max-width: 178px;
  margin-left: var(--space-12);
  border-radius: var(--border-radius-8);
  border: 0.5px solid var(--border-primary);
  background: var(--background-tertiary);
  box-shadow: var(--shadow-card);
  &.copyClip {
    width: 100%;
    max-width: 178px;
    margin-right: var(--space-20);
  }
  ${mobile_xl(css`
    max-width: 190px;
    &.copyClip {
      max-width: 190px;
      margin-inline: var(--space-14);
    }
  `)}
`;

const Showtime = styled.div`
  display: flex;
  justify-content: space-between;
  gap: var(--space-8);
  padding: var(--space-8);
  border-bottom: 0.5px solid var(--border-primary);

  .record-icon {
    margin-right: var(--space-4);
    rect {
      fill: var(--text-secondary);
    }
  }
  .clip-icon {
    stroke: var(--text-primary);
  }
`;

const Time = styled.div`
  color: var(--text-primary);
  ${Typography.body_md}
  white-space: nowrap;
`;

const StopButton = styled.div`
  ${FlexCenter}
  padding: var(--space-8) var(--space-20);
  color: var(--text-primary);
  ${Typography.body_md_medium}
  &:hover {
    cursor: pointer;
    background-color: var(--neutral-secondary);
    border-radius: var(--border-radius-0) var(--border-radius-0) var(--border-radius-8) var(--border-radius-8);
  }
`;

const RecordText = styled.div<Props>`
  ${AlignCenter}
  justify-content: flex-start;
  gap: var(--space-4);
  .record-icon {
    fill: var(--text-secondary);
  }
  p {
    color: var(--text-primary);
    ${Typography.body_md_medium}
    margin: var(--space-0);
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    max-width: ${({ hasHours, isRecorded }) => (hasHours ? '50px' : isRecorded ? '100%' : '76px')};
  }
`;

export { RecordTime, Showtime, Time, StopButton, RecordText };
